import React, { useState, useEffect } from "react";
import "./DatabaseEntries.css";

export default function DatabaseEntries({
  entries,
  people,
  newAdd,
  deletePeople,
  toggleEdit,
  firstEntrySelected,
  cancelToggle,
  cancelKey,
}) {
  let selectedKey;
  const [selected, setSelected] = useState(newAdd);

  useEffect(() => {
    let addSelected = newAdd;
    if (cancelToggle) {
      addSelected = people.filter((person) => person.key === cancelKey);
      addSelected = addSelected[0];
    }

    firstEntrySelected ? setSelected(people[0]) : setSelected(addSelected);
  }, [newAdd, people, cancelKey, cancelToggle, firstEntrySelected]);

  let peopleList = people.map((person, i) => {
    return (
      <option key={i} value={person.key}>
        {person.firstName}
      </option>
    );
  });
  const selectHandler = (e) => {
    e.preventDefault();
    selectedKey = e.target.value;
    const change = people.find((obj) => obj.key === parseInt(selectedKey));
    newAdd = change;
    setSelected(change);
  };

  const deleteBtnHandler = (e) => {
    e.preventDefault();
    deletePeople(selected.key);
  };

  const editBtnHandler = (e) => {
    e.preventDefault();
    toggleEdit(selected.key);
  };

  return (
    <div className="DatabaseEntriesMain mt-5 border-top pt-4">
      <h3 className="mb-3 mt-0">People in Database: {entries}</h3>
      <div>
        <p className="mb-3">Choose a name to edit in the database:</p>
        <select
          className="form-select mb-3"
          aria-label="Select menu of database entries"
          value={selected.key}
          onChange={selectHandler}
        >
          {peopleList}
        </select>

        <table className="table table-borderless">
          <tbody>
            <tr>
              <td className="col-md-3 col-5">First Name:</td>
              <td className="tableBold col-md-9 col-7">{selected.firstName}</td>
            </tr>
            <tr>
              <td>Last Name:</td>
              <td className="tableBold">{selected.lastName}</td>
            </tr>
            <tr>
              <td>Phone:</td>
              <td className="tableBold">{selected.phone}</td>
            </tr>
          </tbody>
        </table>

        <button
          type="button"
          className="btn btn-dark ps-4 pe-4 pt-3 pb-3 mt-2 me-2"
          onClick={deleteBtnHandler}
        >
          Delete
        </button>

        <button
          type="button"
          className="btn btn-dark ps-4 pe-4 pt-3 pb-3 mt-2"
          onClick={editBtnHandler}
        >
          Edit
        </button>
      </div>
    </div>
  );
}
